import {createStyles, Theme} from "@material-ui/core";
import {buttonContained, buttonContainedLarge, buttonOutlined, buttonOutlinedLarge, dialogTitle, greyInput, primaryColor, styleColors} from "src/main.style";

export const EditEventStyle = (theme: Theme) => createStyles({
  buttonOutlined,
  buttonContained,
  buttonOutlinedLarge,
  buttonContainedLarge,
  dialogTitle,
  greyInput,
  bigDialog : {
    margin: 'auto 8px',
    top: '-22px',
    width: 'calc(100% - 16px)',
    position: 'relative',
  },
  scrollView : {
    width: '100%',
    maxHeight: '100%',
    flex:1,
    overflow: 'auto',
  },
  pane: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 12px 12px',
    boxSizing: 'border-box',
  },
  section : {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    borderBottom: `1px solid ${styleColors.greyMedium1}`,
    gap: '8px',
    padding: '16px 0px',
    overflow: 'hidden',
    maxHeight: '300px',
    transition: 'all 0.3s',
  },
  sectionHidden : {
    maxHeight: '0px',
    padding: '0px',
    borderBottom: '0px',
  },
  moreOptions : {
    width: '100%',
    overflow: 'hidden',
    maxHeight: '1000px',
    transition: 'all 1s',
  },
  row: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden',
    maxHeight: '50px',
    transition: 'all 0.3s',
  },
  rowHidden : {
    maxHeight: 0,
    marginTop: '-8px',
  },
  leftColumn : {
    display: 'flex',
    minWidth: '50px',
    padding: '0px 8px;',
    boxSizing: 'border-box',
  },
  rightColumn : {
    display: 'flex',
    flex: 1,
  },
  highlight : {
    border: "1px solid "+primaryColor,
    borderRadius: '4px',
    minHeight: '30px',
    alignItems: 'center',
  },
  person : {
    display: 'flex',
    flexDirection: 'column',
  },
  personSubtitle : {
    flex:1,
    fontSize: '10px',
    fontWeight: 300,
  },
  fullwidth : {
    flex:1,
    alignSelf: 'center',
  },
  fullwidthInput : {
    flex: 1,
  },
  
  error : {
    color: primaryColor,
    fontSize: '10px',
    fontWeight: 600,
    maxHeight: '0px',
    lineHeight: '12px',
    overflow: 'hidden',
    transition: 'all 0.3s',
  },
  date : {
    minWidth: '130px',
    marginRight: '8px',
    flex:1,
  },
  time : {
    maxWidth: '75px',
    minWidth: '65px',
    transition: 'all 0.3s',
    // justifyContent: 'end',
  },
  overlapWarning : {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    overflow: 'hidden',
    boxSizing: 'border-box',
    maxHeight: '160px',
    padding: '8px 16px',
    borderTop: `1px solid ${styleColors.softYellowBorder}`,
    borderRadius: '0px 0px 4px 4px',
    backgroundColor: styleColors.softYellow,
    transition: 'all 0.3s',
  },
  overlapWarningHidden : {
    maxHeight: '0px',
    paddingTop: '0px',
    paddingBottom: '0px',
    borderWidth: '0px',
  },
  overlapTitle : {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '11px',
    fontWeight: 600,
    color: styleColors.primaryTextBlack87,
  },
  overlapItem : {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '8px',
    fontSize: '12px',
    color: styleColors.primaryTextBlack87,
  },
  overlapItemTitle : {
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  overlapItemTime : {
    flexShrink: 0,
    fontSize: '11px',
    fontWeight: 300,
    whiteSpace: 'nowrap',
    color: styleColors.greyDark1,
  },
  greyIcon : {
    color:styleColors.greyDark1,
  },
  greyBackgroundIcon : {
    color: styleColors.white,
    backgroundColor: styleColors.greyMedium2,
    borderRadius: '40px'
  },
  actions : {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
    position: 'absolute',
    bottom: '0px',
    backgroundColor: styleColors.white,
    width: '100%',
    padding: '8px 12px 12px',
    boxSizing: 'border-box',
    alignItems: 'center',
  },
  progressCircleRoot : {
    position: 'absolute',
    top: '0px',
    width: '100%',
  },
  enableEdit : {
    display:'none',
  },
  disableEdit : {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: styleColors.whiteOverlay72,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  aIEvents : {
    top: '0px',
    width: '100%',
    height: '100%',
    margin: 'auto 0px',
    position: 'relative',
    overflow: 'auto',
    display: 'flex',
    scrollSnapType: 'x mandatory',
    scrollBehavior: 'smooth',
    outline: 'none',
  },
  aIEvent : {
    minWidth: 'calc(100% - 32px)',
    margin: 'auto 5px',
    position: 'relative',
    maxWidth: 'calc(100% - 32px)',
    display: 'flex',
    maxHeight: 'calc(100% - 64px)',
    flexDirection: 'column',
    overflowY: 'auto',
    boxShadow: `0px 11px 15px -7px ${styleColors.blackAlpha18}, 0px 24px 38px 3px ${styleColors.blackAlpha12}, 0px 9px 46px 8px ${styleColors.blackAlpha12}`,
    borderRadius: '4px',
    color: styleColors.primaryTextBlack87,
    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    backgroundColor: styleColors.white,
    scrollSnapStop: 'always',
    scrollSnapAlign: 'start',
    scrollMarginLeft: '5px',
  },
  aIMarkdownHeader : {
    position: 'sticky',
    top: 0,
    zIndex: 1,
    flexShrink: 0,
    backgroundColor: styleColors.white,
  },
  onlyEvent : {
    margin: 'auto 12px',
    maxWidth: 'calc(100% - 24px)',
    minWidth: 'calc(100% - 24px)',
  },
  eventSent : {
    transform: 'scale(1)',
    animation: `$scaleUpAndMove 1s forwards ease-in`,
    transformOrigin: 'top center',
    pointerEvents: 'none',
  },
  '@keyframes scaleUpAndMove': scaleUpAndMove,
  eventDeleted : {
    transform: 'scale(1)',
    animation: `$dissolve 1s forwards ease-in`,
    transformOrigin: 'bottom left',
    pointerEvents: 'none',
  },
  '@keyframes dissolve': dissolve,
  imgThumb : {
    maxHeight: '52px',
    maxWidth: '52px',
    borderRadius: '4px',
    boxShadow: `0px 3px 1px -2px ${styleColors.blackAlpha12}, 0px 2px 2px 0px ${styleColors.blackAlpha23}, 0px 1px 5px 0px ${styleColors.blackAlpha63}`,
  },
  imgButton : {
    minWidth: '54px',
    minHeight: '54px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
});

const scaleUpAndMove = {
  '0%': {
    transform: 'scale(1)',
  },
  '40%': {
    transform: 'translate(0%, -20%) scale(0.5)',
  },
  '60%': {
    transform: 'translate(0%, -150%) scale(0.5)',
  },
  '70%': {
    transform: 'translate(0%, -150%) scale(0.5)',
    minWidth: 'calc(100% - 32px)',
    maxWidth: 'calc(100% - 32px)',
    margin: 'auto 5px',
  },
  '100%': {
    transform: 'translate(0%, -150%) scale(0.5)',
    maxWidth: '0px',
    minWidth: '0px',
    margin: 'auto 0px',
  },
};

const dissolve = {
  '0%': {
    transform: 'translate(0%, 0%) scale(1)',
    opacity: '100%',
  },
  '50%': {
    transform: 'translate(0%, 15%) scale(0.5) rotateZ(25deg)',
    opacity: '71%',
  },
  '70%': {
    transform: 'translate(0%, 30%) scale(0.5) rotateZ(30deg)',
    minWidth: 'calc(100% - 32px)',
    maxWidth: 'calc(100% - 32px)',
    margin: 'auto 5px',
    opacity: '0%',
  },
  '100%': {
    transform: 'translate(0%, 70%) scale(0.5) rotateZ(35deg)',
    maxWidth: '0px',
    minWidth: '0px',
    margin: 'auto 0px',
    opacity: '0%',
  },
};



// WEBPACK FOOTER //
// ./src/components/calendar2/eventdetails/EditEvent.style.ts